import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const { sm, xs, md } = constants.breakpoints.BreakpointNames;
const { ui } = constants.colors;

const greyDark = ui.neutral[700];
const neutral600 = ui.neutral[600];

export const container = {
  marginBottom: "24px",
  paddingTop: "24px",
  width: "100%",
  display: "flex",
  gap: "16px",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  textAlign: "center",
  padding: "0.75em 1em 2.5em 1em",
  [mq.downTo(sm)]: {
    padding: "0.75em 2.5em 2.5em 2.55em",
  },

  [mq.downTo(md)]: {
    padding: "0.75em 5em 2.5em 5em",
  },
};

export const headerWrapper = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  alignItems: "flex-start",
  justifyContent: "flex-start",

  [mq.downTo(xs)]: {
    flexDirection: "row",
  },
};

export const heading = {
  margin: "0px",
  color: neutral600,
  fontFamily: "Noto Serif",
  fontSize: "24px",
  fontWeight: 700,
  lineHeight: "133%",
  [mq.downTo(xs)]: {
    fontSize: "32px",
    lineHeight: "125%",
  },
  [mq.downTo(md)]: {
    fontSize: "40px",
    lineHeight: "120%",
  },
};

export const contentWrapper = {
  width: "100%",
  display: "flex",
  gap: "16px",
  alignItems: "center",
  justifyContent: "flex-start",
  color: greyDark,
  background: "#FFF1C6",
  position: "relative",
  paddingLeft: "16px",
  [mq.downTo(xs)]: {
    paddingLeft: "40px",
  },
  [mq.downTo(md)]: {
    paddingLeft: "80px",
    justifyContent: "space-between",
  },
};

export const textWrapper = {
  width: "100%",
  display: "flex",
  minWidth: "288px",
  maxWidth: "536px",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  fontFamily: "Circular",
  textAlign: "initial",
  zIndex: 2,
  gap: "16px",
  padding: "16px 0px",
  [mq.downTo(xs)]: {
    padding: "24px 0px",
  },
  p: {
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "150%",
    margin: "0px",
  },

  [mq.downTo(xs)]: {
    minWidth: "441px",
    maxWidth: "542px",
  },

  [mq.downTo(sm)]: {
    minWidth: "530px",
    maxWidth: "768px",
  },
};

export const imageWrapper = {
  maxWidth: "454px",
  overflow: "hidden",
  display: "flex",
  position: "absolute",
  justifyContent: "flex-start",
  top: "0px",
  right: "0px",
  [mq.downTo(xs)]: {
    height: "150px",
  },
  [mq.downTo(sm)]: {
    // width: '50%',
    height: "240px",
    position: "initial",
  },
};

export const imageCss = {
  width: "150px",
  content: 'url("/images/icons/challenge_teacher_homepage_image_small.svg")',
  [mq.downTo(xs)]: {
    content: 'url("/images/icons/challenge_teacher_homepage_image_medium.svg")',
  },
  [mq.downTo(sm)]: {
    width: "454px",
    content: 'url("/images/icons/challenge_teacher_homepage_image_large.svg")',
  },
};
